// Registers the PWA service worker (skips localhost dev to avoid hot-reload caching).
export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  const isLocalhost = ["localhost", "127.0.0.1", ""].includes(
    window.location.hostname
  );
  // Register everywhere except local dev so the preview & production are installable.
  if (isLocalhost) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
